import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Footer from "./components/Footer";
import Header from "./components/Header";
import FAQS from "./pages/FAQS";
import LoanCalculator from "./pages/LoanCalculator";
import ApplyLoan from "./pages/ApplyLoan";
import ScrollToTop from "./ScrollToTop";
import TermsAndConditions from "./pages/TermsAndConditions";

function App() {
  const location = useLocation();

  // pages that should not show header and navbar
  const noHeaderFooterRootes = ["/terms-and-conditions", "/privacy-policy"];

  const hideHeaderFooter = noHeaderFooterRootes.includes(location.pathname);

  return (
    <div className="font-sans">
      {!hideHeaderFooter && (
        <div className="fixed top-0 left-0 right-0 z-50">
          <Header />
          <Navbar />
        </div>
      )}

      <div className="pt-[140px]">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/faqs" element={<FAQS />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/loan-calculator" element={<LoanCalculator />} />
          <Route path="/apply-loan" element={<ApplyLoan />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          <Route
            path="*"
            element={<h1 className="text-center">404 Not Found</h1>}
          />
        </Routes>
      </div>

      {!hideHeaderFooter && <Footer />}
    </div>
  );
}

export default App;
